export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14083.00c8f7db.jpg";